import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import {useRouter} from '@s-ui/react-router'

export default function NavigationRequireAuth({children, currentPath}) {
  const {domain} = useContext(Context)
  const {push} = useRouter()
  const [shouldRenderChildren, setShouldRenderChildren] = useState(false)

  const config = domain.get('config')

  const {AMPERSAND_MARK, LOGIN_WITH_LOGIN_SCREEN_PATH_PATTERN} = config.get('page')
  const QUERY_PARAM_TARGET_PAGE = config.get('QUERY_PARAM_TARGET_PAGE')

  const _getIsLogged = async () => {
    const {logged} = await domain.get('verify_authentication_use_case').execute()

    return logged
  }

  const _loggedActions = () => {
    setShouldRenderChildren(true)
  }

  const _notLoggedActions = () => {
    const url = currentPath
      ? `${LOGIN_WITH_LOGIN_SCREEN_PATH_PATTERN}${AMPERSAND_MARK}${QUERY_PARAM_TARGET_PAGE}=${currentPath}`
      : LOGIN_WITH_LOGIN_SCREEN_PATH_PATTERN
    push(url)
  }

  useMount(async () => {
    const userIsLogged = await _getIsLogged()
    userIsLogged ? _loggedActions() : _notLoggedActions()
  })

  return shouldRenderChildren && children
}

NavigationRequireAuth.displayName = 'NavigationRequireAuth'
NavigationRequireAuth.propTypes = {
  children: PropTypes.array,
  currentPath: PropTypes.string
}
